<div fxLayout="column" fxLayoutGap="20px">
  <h1>Perfis</h1>

  <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
    <div fxLayout.gt-md="row" fxLayoutAlign="start start" fxLayoutGap="15px">
      <mat-form-field appearance="outline">
        <mat-label>Consultar usuários com perfil</mat-label>
        <mat-select [formControl]="opcaoPerfilFC">
          <mat-option *ngFor="let perfil of perfis" [value]="perfil.idPerfil">
            {{ perfil.nome }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button
        title="Adicionar usuário ao perfil"
        mat-raised-button
        color="primary"
        (click)="adicionarUsuarioDialog()"
        [disabled]="opcaoPerfilFC.value === ''">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
    <div fxLayout.gt-md="row" fxLayoutAlign="start start" fxLayoutGap="15px">
      <mat-form-field appearance="outline">
        <mat-label>Consultar perfis do usuário</mat-label>
        <input matInput [formControl]="buscaPerfis" />
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        routerLink="{{ buscaPerfis.value }}"
        [disabled]="buscaPerfis.value === ''">
        <mat-icon>search</mat-icon>
      </button>
    </div>
  </div>

  <div>
    <app-search-input #searchInput (search)="search($event)" placeholder=""></app-search-input>
  </div>

  <div>
    <table mat-table #table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
        <td mat-cell *matCellDef="let usuario">{{ usuario.nome }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>E-mail</th>
        <td mat-cell *matCellDef="let usuario">{{ usuario.emailPrincipal }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="w-140"></th>
        <td mat-cell *matCellDef="let usuario">
          <button mat-icon-button color="warn" (click)="excluir(usuario)" title="Excluir">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="3">
          <app-table-no-data [searchValue]="searchInput.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator></app-default-paginator>
  </div>
</div>
